import { fromJS } from "immutable";
import * as constants from "./constants";

const defaultState = fromJS({
  accountInfo: {},
  loadingAccountInfo: true,
  loadingPlanInfo: true,
  allAccount: [],
  profile: {},
  saved: false,
  planInfo: [],
  planDetail: [],
  billHistory: [],
  emailSummary: {},
  saving: false,
  sendingEmail: { id: "", sending: false },
  formValue: {},
  orgType: "claiming",
  timezoneOptions: [],
  config: {},
  isFormDirty: false,
  integration: null,
  // used to disable owner role changes when there's already a pending request
  requestingOwner: false,
  // used for xero integration
  loadingXeroInfo: true,
  xeroSettings: {},
  xeroAccounts: [],
  xeroTrackingCategories: [],
  xeroSettingsConfigured: false,
});

const setData = (state, action) => {
  if (action.name === "accountInfo") {
    return state.merge({
      loadingAccountInfo: false,
      accountInfo: fromJS(action.data),
    });
  } else if (action.name === "xeroSettings") {
    return state.merge({
      loadingXeroInfo: false,
      xeroSettings: fromJS(action.data),
    });
  } else {
    return state.set(action.name, fromJS(action.data));
  }
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case constants.RESET:
      return defaultState.set(
        "xeroSettingsConfigured",
        state.get("xeroSettingsConfigured") || false,
      );
    case constants.SET_DATA:
      return setData(state, action);
    default:
      return state;
  }
};
